import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import VerticalInsightsElements from "./routes/VerticalInsightElements";
import ProgrammeOfInquiry from "./routes/ProgrammeOfInquiry";

export default store => ({
  path: "vertical-insights",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "vertical-insights" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [ProgrammeOfInquiry(store), VerticalInsightsElements(store)],
});
